module.exports = __webpack_public_path__ + "static/media/TransferStampLogo.f8179204.svg";